import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ModalService } from '@src/shared/modal/modal.service';
import { orderBy } from 'lodash-es';
import { FileService, FileType } from '../../woo_services.module/FileService';
import { TranslationService } from '../../woo_services.module/TranslationService';

@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html',
  standalone: false,
})
export class FileUpload {
  uploadedFiles: any;
  fileTypes: FileType[];
  newFile = {
    fileType: '',
    file: null,
    name: '',
  };
  translateFileType: (fileType: string) => string;
  getUrlToFile: (fileId: string) => string;

  constructor(
    private translationService: TranslationService,
    private fileService: FileService,
    private modalService: ModalService,
  ) {
    this.translateFileType = this.translationService.convertFileUploadTypes;
    this.getUrlToFile = this.fileService.getUrlToFile;
    this.loadFiles().then();
    this.fileService.listTypes().then((types) => {
      this.fileTypes = types;
    });
  }

  loadFiles = async (): Promise<void> => {
    this.uploadedFiles = orderBy(await this.fileService.listFiles(), (file) => this.translateFileType(file.file_type));
  };

  uploadFile = async (form: NgForm): Promise<void> => {
    const loaderModal = this.modalService.openLoader('Laddar upp fil...');
    await this.fileService
      .uploadFile(this.newFile.file, this.newFile.fileType as FileType)
      .then(() => {
        this.loadFiles();
        this.modalService.openSuccess('Filen laddades upp!');
        form.resetForm();
      })
      .catch(() => {
        this.modalService.openError('Filen kunde inte laddas upp.');
      })
      .finally(() => {
        loaderModal.close();
      });
  };
}
